import Header from 'components/Header';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import useStore from '../store';

function HomeLayout(): ReactElement {
  const { t } = useTranslation();
  const { selectedSubject } = useStore();
  return (
    <Header
      headerTitle={selectedSubject ? selectedSubject.name : `${t('selectSubject')}`}
      showBack={!!selectedSubject}
    >
      <Outlet />
    </Header>
  );
}

export default HomeLayout;
